import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { PlusIcon, TrashSimpleIcon } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { StyledAddArt as StyledAddExpo } from "../AddArt/AddArt.styled";
import { useProfile } from "../../stores/useProfile";
import { useExpo } from "../../stores/useExpo";
import { ExpoDto } from "../../Models/ExpoDto";

export const AddExpo = () => {
  const { addExpo } = useExpo();
  const { user } = useProfile();

  const [previewImages, setPreviewImages] = useState<string[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [title, setTitle] = useState("");
  const [time, setTime] = useState("");
  const [location, setLocation] = useState("");
  const [info, setInfo] = useState("");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const newFiles = Array.from(files);
    const filePreviews = newFiles.map((file) => URL.createObjectURL(file));

    setSelectedFiles((prev) => [...prev, ...newFiles]);
    setPreviewImages((prev) => [...prev, ...filePreviews]);
  };

  const handleRemoveImage = (indexToRemove: number) => {
    setPreviewImages((prev) => {
      URL.revokeObjectURL(prev[indexToRemove]);
      return prev.filter((_, index) => index !== indexToRemove);
    });
    setSelectedFiles((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  // 💾 Submit Expo
  const onSave = async () => {
    if (!user) return;

    const expo: ExpoDto = {
      title,
      time,
      location,
      info,
      files: selectedFiles,
    };

    const result = await addExpo(user, expo);
    if (result === 201) {
      console.log("✅ Expo created successfully");
      setPreviewImages([]);
      setSelectedFiles([]);
      setTitle("");
      setTime("");
      setLocation("");
      setInfo("");
    } else {
      console.error("❌ Failed to create expo:", result);
    }
  };

  useEffect(() => {
    return () => {
      previewImages.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [previewImages]);

  return (
    <StyledAddExpo>
      {/* File Upload Section */}
      <Box className="imageWrapper">
        <Button variant="contained" component="label" className="addimageBtn">
          <PlusIcon size={64} />
          <input
            hidden
            accept="image/*"
            type="file"
            multiple
            onChange={handleFileChange}
          />
        </Button>

        {previewImages.map((src, index) => (
          <Box key={index} className="image">
            <img
              src={src}
              alt={`preview-${index}`}
              className="previewImage"
            />
            <TrashSimpleIcon
              size={32}
              weight="bold"
              onClick={() => handleRemoveImage(index)}
            />
          </Box>
        ))}
      </Box>

      {/* Expo Form Section */}
      <Box className="artForm">
        <Box className="row">
          <Box className="column">
            <Typography variant="h3">Titel</Typography>
            <TextField
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Box>
          <Box className="column">
            <Typography variant="h3">Tijd</Typography>
            <TextField
              fullWidth
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
          </Box>
        </Box>

        <Box className="row">
          <Box className="column">
            <Typography variant="h3">Locatie</Typography>
            <TextField
              fullWidth
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </Box>
          <Box className="column">
            <Typography variant="h3">Informatie</Typography>
            <TextField
              fullWidth
              value={info}
              onChange={(e) => setInfo(e.target.value)}
              multiline
              rows={4}
            />
          </Box>
        </Box>

        <Box className="row">
          <Button className="savebtn" onClick={onSave}>
            Opslaan
          </Button>
        </Box>
      </Box>
    </StyledAddExpo>
  );
};
